import { useConnectivity } from './connectivity';
import type { Connectivity } from './connectivity';
import { useOutboxStatus } from './outbox';

/**
 * Connectivity + sync status for the shell pill and the connection banner (ADR-037). `pending`
 * counts commands waiting in the outbox: ones sent while online whose answer has not come back yet
 * (nothing new is queued while the server cannot be reached).
 */
export interface SyncStatus {
  online: boolean;
  connectivity: Connectivity;
  pending: number;
  state: 'synced' | 'offline' | 'lost' | 'syncing';
}

export function useSyncStatus(): SyncStatus {
  const connectivity = useConnectivity();
  const box = useOutboxStatus();
  const online = connectivity === 'online';
  return {
    online,
    connectivity,
    pending: box.pending,
    state: !online ? connectivity : box.pending > 0 || box.flushing ? 'syncing' : 'synced',
  };
}

/** Whether anything that needs the server now can be started (ADR-037). */
export function useOnline(): boolean {
  return useConnectivity() === 'online';
}
